import { Component, OnInit } from '@angular/core';
import { MeasurementUnit } from 'app/mdm/terminology-lib/services/measurement-unit';
import { MeasurementUnitService } from 'app/mdm/terminology-lib/services/measurement-unit.service';

@Component({
  templateUrl: 'measurement-unit-list.component.html',
})
export class MeasurementUnitListComponent implements OnInit {
  public editPrivileges = ['mdm.admin.edit'];
  public viewPrivileges = ['mdm.admin.view'];

  public measurementUnits: MeasurementUnit[];
  public search: any;
  public loading: boolean;

  constructor(private measurementUnitService: MeasurementUnitService) {}

  public ngOnInit(): void {
    this.searchMeasurementUnits();
  }

  public searchMeasurementUnits(): void {
    this.loading = true;
    this.measurementUnitService.query().subscribe((resp) => {
      this.measurementUnits = resp;
      this.loading = false;
    });
  }
}
